import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

const Params = {
  read: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getParametrosCliente',
      method: 'post'
    })
  },

  save: (params) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/saveParametrosCliente',
      method: 'post',
      body: params
    })
  },

  getCountries: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getCountryFilter',
      method: 'post'
    })
  },
  getNewsLetter: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getNewsLetter',
      method: 'post'
    })
  },
  getNewsGesintel: (currentUser) => {
    let idCategory = 60
    if(currentUser.cliente.pais === 'PER') {
      idCategory = 70
    }else if(currentUser.cliente.pais === 'CR') {
      idCategory = 69
    }else if(currentUser.cliente.pais === 'COL') {
      idCategory = 68
    }
    return apiRequestorHelper({
      url: 'https://www.gesintel.cl/wp-json/wp/v2/posts?_embed&categories='+idCategory+'&per_page=10',
      method: 'get'
    }, false)
  },
  getOptions: (option) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getOptionsRisk',
      method: 'post',
      body: {option}
    })
  },
  importSelected: (formData) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/uploadOptionsRisk',
      method: 'post',
      body: formData
    })
  },
  getC57FormHistory:(id) => {
    return apiRequestorHelper(
        {
          url: apiConfig.url + '/c57FormHistory/' + id,
          method: 'get'
        }
    )
  },

  getCausasPenalesDetail: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getCausasPenalesDetail',
      method: 'get'
    })
  },

  excelCategoriasDelitos: (params = {}) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/excelCategoriasDelitos',
      method: 'post',
      body: params,
      responseType: 'blob'
    })
  },

  updateCategoriaDelito: (params) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/updateCategoriaDelito',
      method: 'post',
      body: params
    })
  },

  uploadCategoriasDelitos: (formData) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/uploadCategoriasDelitos',
      method: 'post',
      body: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
}
export default Params